module.exports = require('./lib/visibility.timers.js')



//////////////////
// WEBPACK FOOTER
// ./~/visibilityjs/index.js
// module id = 2881
// module chunks = 0